module.exports = __webpack_public_path__ + "img/russia.1b5d5acd.svg";